import { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Put, Delete } from "../../../../Services/Server";
import Url from "../../../../Services/Url";
import Head from "../../../../Components/Head/Head";
import Form from "../../../../Components/Form/Form";
import { toast } from "react-toastify";
import AddAnnouncementFormOptions from "../AnnouncementFormOptions";
import AnnouncementViewFormOptions from "../AnnouncementViewFormOptions";
import Utils from "../../../../Services/Utills";
import { ROLES } from "../Roles";
import "../AddAnnouncement/AddAnnouncement.css";
import { ModalAction } from "../../../../Routes/NavRouter";

const AnnouncementDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const announcementData = location.state;

  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState(null);

//   const confirmOption = {
//     title: "Delete Announcement",
//     text: "Are you sure you want to delete this announcemen?",
//     // options: group,
//     exitText: "Exit",
//     okText: "Continue",
//     onOk: deletee,
// };

 
const deleteAnnouncement = useCallback(() => {
    Delete(Url.notification.delete(id))
      .then(() => {
        toast.success("Announcement deleted");
        navigate(-1);
      })
      .catch((error) => {
        console.error("Error deleting announcement:", error);
        toast.error("Failed to delete announcement");
      });
  }, [id, navigate]);

const handleDelete = useCallback(() => {
    ModalAction.confirm({
      title: "Confirm Delete",
      text: "Are you sure you want to delete this announcement?",
      exitText: "Exit",
     okText: "Delete",
      onOk: deleteAnnouncement,
    });
  }, [deleteAnnouncement]);


  const handleSave = useCallback(() => {
    setLoading(true);

    const dataObject = Utils.FormObject(options);
    const allRoleIds = ROLES.map((role) => role.id);
    const isAllUsersSelected =
      dataObject.userConfiguration.length === allRoleIds.length;


    const payload = {
      title: dataObject.title,
      message: dataObject.content,
      startDate: dataObject.startDate,
      endDate: dataObject.endDate,
      visibility: isAllUsersSelected,
      roleIds: isAllUsersSelected
        ? []
        : dataObject.userConfiguration.map((id) => parseInt(id, 10)),
    };

    Put(Url.notification.update(id), payload)
      .then(() => {
        toast.success("Announcement updated");
        setIsEditing(false);
      })
      .catch((error) => {
        console.error("Error updating announcement:", error);
        toast.error("Failed to update announcement");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, options]);

  useEffect(() => {
    if (announcementData) {
      const baseOptions = isEditing
        ? AddAnnouncementFormOptions
        : AnnouncementViewFormOptions;

      const newOptions = { ...baseOptions, Fields: [] };

      newOptions.Fields = baseOptions.Fields.map((field) => {
        if (Array.isArray(field)) {
          return field.map((subField) => {
            const newSubField = { ...subField };
            newSubField.value = announcementData[newSubField.name] ?? null;
            return newSubField;
          });
        } else {
          const newField = { ...field };
          newField.value = announcementData[newField.name] ?? null;

          if (newField.name === "userConfiguration") {
            const allRoleIds = ROLES.map((role) => role.id);
            if (announcementData.visibility) {
              newField.value = allRoleIds;
            } else if (announcementData.roleIds) {
              newField.value = announcementData.roleIds;
            }
          }

          return newField;
        }
      });

      // Override only Edit, Cancel, Delete (leave Save for form submit)
      newOptions.Buttons = newOptions.Buttons.map((btn) => {
        if (btn.text === "Cancel") {
          return { ...btn, onClick: () => setIsEditing(false) };
        }
        if (btn.text === "Edit") {
          return { ...btn, onClick: () => setIsEditing(true) };
        }
        if (btn.text === "Delete") {
          return { ...btn, onClick: handleDelete };
        }
        if (btn.text === "Save") {
          return { ...btn, type: "submit", disabled: loading }; // prevent double save
        }
        return btn;
      });

      setOptions(newOptions);
    }
  }, [announcementData, isEditing, handleDelete, loading]);

  if (!options) {
    return <div>Loading...</div>;
  }

  return (
    <div className="announcement-details">
      <Head title="Announcement Details" />
      <div className="form-container">
        <h2 className="form-title">Announcement Details</h2>
        <Form onSubmit={handleSave}>{options}</Form>
      </div>
    </div>
  );
};

export default AnnouncementDetails;
